import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ChangePassword } from '../auth/auth';

@Injectable()
export class UserService {
  constructor(private http: HttpClient) {}

  changeCurrentPassword(changePasswordData: ChangePassword) {
    return this.http.post(`/auth/change_password`, changePasswordData);
  }
}
